import { observable } from "mobx";

export class AcceptedBetModel {
    @observable ticketId: string;
    message: string;
    ticketLabel: string;
    @observable timeInterval: string;
    buttonLabel: string;
    handler: any;
    areaHandler: any;
    constructor(source: AcceptedBetModel) {
        this.ticketId = source.ticketId;
        this.message = source.message;
        this.ticketLabel = source.ticketLabel;
        this.timeInterval = source.timeInterval;
        this.buttonLabel = source.buttonLabel;
        this.handler = source.handler;
        this.areaHandler = source.areaHandler;
    }
}